// node_modules
import React, { useContext, useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { format, parse } from "date-fns";
import { ToastContext } from "../../App";

// hooks
import { useWS } from "../../hooks/useWS";
import { diningOptionApi } from "../../redux/services/diningOption";
import { foodStationApi } from "../../redux/services/foodStation";
import { foodStationOptionsApi } from "../../redux/services/foodStationOptions";
import {organizationApi} from '../../redux/services/organization'

// redux
import { setOpenedStations } from "../../redux/slices/stations.slice";
import { useSelector, useDispatch } from "react-redux";
import { setVapidKey, setLoading } from "../../redux/slices/app.slice";
import { setOrders } from "../../redux/slices/order.slice";

// components
import StudentHome from "./StudentHome";
import OrderPage from "./OrderPage";
import OrderStatusPage from "./OrderStatusPage";
import Footer from "../../components/Footer";

// assets
import BackgroundEllipse from "../../assets/closed_stations_ellipse.svg";

// utils
import getSubdomain from "../../utils/getSubdomain";
import Root from "../Root";

// styles
import * as styles from "./StudentPortal.module.css";

const StudentPortal = () => {
  const [showLoader, setShowLoader] = useState(true);
  const { ws } = useWS({ token: null, stationId: null, skipAuth: true });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stationsChanged, setStationsChanged] = useState(false);
  const showToast = useContext(ToastContext);
  const openedStations = useSelector((state) => state.stations.openedStations);

  useEffect(() => {
    dispatch(setLoading(true));
  }, []);

  useEffect(() => {
    if (!ws) return;

    localStorage.removeItem("auth_token");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    ws.addEventListener("open", (event) => {
      console.log("Open!", event);
      setInterval(() => {
        ws.send(JSON.stringify({ type: "ping" }));
      }, 1000 * 55);
      ws.addEventListener("message", (event) => {
        const data = JSON.parse(event.data);
        const uuid = localStorage.getItem("uuid");

        if (data.id) {
          if (uuid) {
            ws.send(
              JSON.stringify({
                type: "set-user-id",
                data: { id: uuid },
              })
            );
          } else {
            localStorage.setItem("uuid", data.id);
            ws.send(
              JSON.stringify({
                type: "current-stations",
                data: {
                  customer_id: data.id,
                  subdomain: getSubdomain(),
                  time: format(new Date(), "HH:mm"),
                },
              })
            );
          }
        }

        if (data.status === "success") {
          ws.send(
            JSON.stringify({
              type: "current-stations",
              data: {
                customer_id: uuid,
                subdomain: getSubdomain(),
                time: format(new Date(), "HH:mm"),
              },
            })
          );

          ws.send(
            JSON.stringify({
              type: "order-status",
              data: { customer_id: uuid },
            })
          );
        }

        if (data.type === "update-available-stations") {
          ws.send(
            JSON.stringify({
              type: "current-stations",
              data: {
                customer_id: uuid,
                subdomain: getSubdomain(),
                time: format(new Date(), "HH:mm"),
              },
            })
          );
        }

        if (data.type === "available-stations") {
          dispatch(setOpenedStations(data.data));
          dispatch(setLoading(false));
        }

        if (data.type === "order-status") {
          dispatch(setOrders(data.data));
        }

        if(data.type === "organization-changed") {
          if(data.data && data.data === 'Subdomain changed') {
            showToast(
              "info",
              "Organization",
              "Organization subdomain changed"
            );
            if(window.location.protocol === 'https:')
              window.location.href = `https://${getBaseUrl()}`
            else window.location.href = `http://${getBaseUrl()}`
          } else {
            dispatch(organizationApi.util.invalidateTags([{type: "NotificationOptions"}]));
            showToast(
              "info",
              "Organization",
              "Please check out the new notification options!"
            );
          }
        }
        
        if (data.type === "station-changed") {
          if (
            +window.location.href.slice(
              window.location.href.indexOf("make-order/") + 11
            ) === data.data.station_id
          ) {
            dispatch(
              diningOptionApi.util.invalidateTags([{ type: "DiningOptions" }])
            );
            dispatch(
              foodStationOptionsApi.util.invalidateTags([
                { type: "FoodStationOptions" },
              ])
            );
            showToast(
              "info",
              "The Food Station refreshed!",
              "Please check out the new options!"
            );
            setStationsChanged(true);
          } else {
            ws.send(
              JSON.stringify({
                type: "current-stations",
                data: {
                  customer_id: uuid,
                  subdomain: getSubdomain(),
                  time: format(new Date(), "HH:mm"),
                },
              })
            );
          }
        }

        if (data.key) {
          dispatch(setVapidKey(data.key));
        }
      });
    });

    ws.addEventListener("error", (event) => {
      console.log("Error!", event);
    });

    ws.addEventListener("close", (event) => {
      navigate(0);
      console.log("Close!", event);
    });
  }, [ws]);

  const sendViaWS = (message) => {
    ws.send(JSON.stringify({ ...message }));
  };

  return (
    <div
      style={{
        background: `${
          openedStations?.length === 0
            ? `url(${BackgroundEllipse}) right / 50% 100% no-repeat, linear-gradient(#F5F2ED, #FBFAF9)`
            : ""
        } `,
      }}
      className={`${styles.wrapper} ${
        openedStations?.length === 0 ? styles.closedPage : ""
      }`}
    >
      {getSubdomain().startsWith("localhost") || getSubdomain() === "dwtl" ? (
        <Root />
      ) : (
        <div>
          <Routes>
            <Route path="/" element={<StudentHome sendViaWS={sendViaWS} />} />
            <Route
              path="/make-order/:id"
              element={
                <OrderPage
                  sendViaWS={sendViaWS}
                  stationChanged={stationsChanged}
                  setStationChanged={setStationsChanged}
                />
              }
            />
            <Route path="/order-status" element={<OrderStatusPage />} />
          </Routes>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default StudentPortal;
